import { AbstractClient } from './AbstractClient';
import FormData from 'isomorphic-form-data';

export class ClientSubmissionClient extends AbstractClient {
  async uploadDecPage(
    submissionId: string,
    fileName: string,
    file: NodeJS.ReadableStream,
  ) {
    const formData = new FormData();
    formData.append('files[]', file, fileName);
    await this.client.post(
      `/${submissionId}/upload-declaration-page-files`,
      formData,
      { headers: formData.getHeaders() },
    );
  }
}
